import {ReactComponent as CreateIcon} from "../../Icons/create.svg";
import NotesDialog from './NotesDialog';
import OutlinedButton from '../OutlinedButton';
import React from 'react';
import { getEntryNote } from "../../Utils/Api";
import LoadingOverlay from "../LoadingOverlay";

export default function NotesDialogWithButton({ awardId, entryId, title, categoryId = null, buttonProps = {}, ...props }) {
    const [diaglogState, setDialogState] = React.useState({ open: false });
    const [content, setContent] = React.useState( null );

    const handleClickOpen = () => {
        setDialogState({ open: true });

        (async () => {
            const noteResp = await getEntryNote({awardId, entryId, categoryId});

            if(!noteResp || noteResp.response.status !== 200 || !noteResp.data || noteResp.data.status !== "OK") {
                console.error("Error loading note", noteResp);
                return;
            }
            else {
                setContent(noteResp.data.note);
            }
        })();
    }
    
    function handleClose(e, awardId, entryId, content) {
        setDialogState({ open: false });
        buttonProps.isActive = content?.length;
    }

    function handleChange(e, content) {
        setContent(content);
    }
    
    return (
        <>
            <OutlinedButton icon={CreateIcon} text="Notes" onClick={handleClickOpen} {...buttonProps} />
            {diaglogState.open && (
                content === null ? (
                    <LoadingOverlay />
                ) : (
                    <NotesDialog 
                        awardId={awardId} 
                        entryId={entryId} 
                        categoryId={categoryId}
                        title={title} 
                        content={content}
                        {...props} 
                        diaglogState={diaglogState} 
                        setDialogState={setDialogState}
                        handleChange={handleChange} 
                        handleClose={handleClose}
                    />
                )
            )}
        </>
    );
}